import {ChangeEvent, useContext, useEffect, useRef, useState} from 'react'
import {toast} from 'react-toastify'
import {maxBallsCount} from '../../config'
import Toggle from 'react-toggle'
import 'react-toggle/style.css'
import Dropdown from "../Dropdown";
import {Context} from "../../../../index";
import {unpack, pack} from "../../../../Utils/forSocket";
import ErrorComponent from "../../../../components/UI/Error/ErrorComponent";
import PlinkoService from "../../PlinkoService";
import {fillTextPage} from "../../../../Utils/FillTextPage";
import {observer} from "mobx-react-lite";

let timerId = null

const BetAction = ({
                       onRunBet,
                       onChangeLines,
                       onChangeRisk,
                       inGameBallsCount,
                       autoBallCount,
                       onChangeAutoBallCount,
                       isAuto,
                       onChangeIsAuto,
                       leftBallCount,
                       onChangeLeftBallCount,
                       mainSchema,
                       muted,
                       onChangeMuted,

                   }) => {


    const {store} = useContext(Context)
    useEffect(() => {
        fillTextPage("plinko",store)
    }, []);

    const isLoading = false
    const isAuth = true
    const [betValue, setBetValue] = useState(20)
    const incrementBalance = (value) => {
        store.user.balance += value;
    }
    const [curId, setCurId] = useState(0)
    const curIdRef = useRef(null)

    curIdRef.current = curId
    // const maxLinesQnt = 16;
    const riskOptions = ['Low', 'Mid', 'High']
    const linesOptions = [8, 12, 16]
    const [statusRunBall,setStatusRunBall] = useState(true)

    // for (let i = 8; i <= maxLinesQnt; i++) {
    // 	linesOptions.push(i);
    // }

    // const handleChangeRisk = (e: ChangeEvent<HTMLSelectElement>) => {
    // 	if (!isAuth || isLoading) return
    // 	e.preventDefault()
    // 	onChangeRisk(e.target.value as any)
    // }

    const handleChangeRisk = (option) => {
        if (!isAuth || isLoading) return
        onChangeRisk(option)
    }

    const handleChangeBetValue = (e) => {
        if (!isAuth || isLoading) return
        e.preventDefault()
        setBetValue(e.target.value)
    }

    const handleChangeLines = (option) => {
        if (!isAuth || isLoading) return

        onChangeLines(option)
    }

    const handleHalfBet = () => {
        if (!isAuth || isLoading) return
        const value = Math.floor(betValue / 2)
        const newBetvalue = isNaN(value) || value < 0 ? 0 : Number(value.toFixed(4))
        setBetValue(newBetvalue)
    }

    const handleDoubleBet = () => {
        if (!isAuth || isLoading) return
        const value = betValue * 2
        const newBetvalue =
            isNaN(value) || value > store.user.balance ? 0 : Number(value.toFixed(4))
        setBetValue(newBetvalue)
    }

    const handleMaxBet = () => {
        if (!isAuth || isLoading) return
        setBetValue(10000)
    }

    const handleAutoBallCountChange = (e) => {
        const value = parseInt(e.target.value)
        onChangeAutoBallCount(Number(value))
    }
    async function create_bet(betValue){
        try {


            const responeCreate = await PlinkoService.create_bet(betValue)
            const data = responeCreate.data;

            if (data.error) {
                store.add_message(data.msg, ErrorComponent)
                onRunBet(betValue, data.idBall,0)

            }
            if (data.msg === "ok") {
                store.user.balance = data.userBalance
                onRunBet(betValue, data.idBall)

            }
        }
        catch (e){
            console.error(e)
            store.add_message("error1",ErrorComponent)
        }
    }
    const handleRunBet = async () => {
        if (inGameBallsCount >= maxBallsCount) return
        if (timerId){
            store.add_message(store.dataLang["error_run_bet_plinko"],ErrorComponent)
            return
        }

        if (!isAuto) {

            if (statusRunBall){
                create_bet(Number(betValue));
                setStatusRunBall(false)
                setTimeout(()=>{
                    setStatusRunBall(true)
                },400)
            }




            return
        }


        const count = !isAuto ? 1 : isNaN(autoBallCount) ? 1 : autoBallCount
        onChangeAutoBallCount(count)
        onChangeLeftBallCount(count)


        timerId = setInterval(() => {
            if (curIdRef.current === count) {
                setCurId(0)
                clearInterval(timerId)
                timerId = null
            } else {

                create_bet(Number(betValue));


                // incrementBalance(betValue * -1)



                setCurId((prev) => prev + 1)
            }
        }, 500)
    }

    return (
        <div className={`bet-action ${inGameBallsCount > 0 ? 'disabled' : ''}`}>
            <div className="game-type">
                <button
                    className={!isAuto ? 'active' : ''}
                    onClick={() => onChangeIsAuto(false)}
                    disabled={inGameBallsCount > 0}
                >
                    {store.dataLang["variant_button1"]}
                </button>
                <button
                    className={isAuto ? 'active' : ''}
                    onClick={() => onChangeIsAuto(true)}
                    disabled={inGameBallsCount > 0}
                >
                    {store.dataLang["variant_button2"]}
                </button>
            </div>
            <div className="bet-amount">
                <span className="title">{store.dataLang["headers1"]}</span>
                <div className="input-box highlight-hover">
                    <span>₽</span>
                    <input
                        type="number"
                        onChange={handleChangeBetValue}
                        value={betValue}
                        disabled={inGameBallsCount > 0}
                    />
                    <div>
                        <button onClick={handleHalfBet} disabled={inGameBallsCount > 0}>
                            x1/2
                        </button>
                        <button onClick={handleDoubleBet} disabled={inGameBallsCount > 0}>
                            x2
                        </button>
                        <button onClick={handleMaxBet} disabled={inGameBallsCount > 0}>
                            Max
                        </button>
                    </div>
                </div>
            </div>
            <div className="risk">
                <span className="title">{store.dataLang["headers2"]}</span>
                <Dropdown
                    options={riskOptions}
                    defaultValue="Low"
                    onChange={handleChangeRisk}
                    disabled={inGameBallsCount > 0 ? true : false}
                />
            </div>
            <div className="rows">
                <span className="title">{store.dataLang["headers3"]}</span>
                <Dropdown
                    options={linesOptions}
                    defaultValue={8}
                    onChange={handleChangeLines}
                    disabled={inGameBallsCount > 0 ? true : false}
                />
            </div>
            {isAuto ? (
                <div className="number-of-bets">
                    <span className="title">{store.dataLang["headers4"]}</span>
                    <div className="highlight-hover">
                        <input
                            type="number"
                            value={autoBallCount}
                            onChange={handleAutoBallCountChange}
                            disabled={inGameBallsCount > 0}
                        />
                    </div>
                </div>
            ) : (
                <></>
            )}
            <button
                className="send-ball"
                onClick={async () => {
                    handleRunBet()
                }}
                disabled={inGameBallsCount > 0 && isAuto}
                style={{
                    cursor: `${inGameBallsCount > 0 && isAuto ? 'not-allowed' : 'pointer'}`,
                }}
            >
                {store.dataLang["run_bet"]}
            </button>
            <div className="toggle-button">
                <Toggle
                    checked={!muted}
                    onChange={() => onChangeMuted(!muted)}
                    // icons={{
                    //   checked: <UnMuteIcon className="mute-icon" />,
                    //   unchecked: <MuteIcon className="mute-icon" />,
                    // }}
                    className="mute-toggle"
                />
            </div>
        </div>
    )
}

export default observer(BetAction)